require('../../fhApp/transformResource');

angular.module('app.admin.passManager.passManagerService', [
  'app.transformResource'
])
  .factory('app.admin.passManager.passManagerService', [
    '$http',
    '$q',
    'app.transformResource',
    function ($http, $q, transformResource) {

      return {
        createAccess: function (access) {

          return $http.post(window.location.api('security/access'), {
            iaccessscopeid_fk: access.iaccessscopeid_fk,
            iuseraffiliationtypeid_fk: access.iuseraffiliationtypeid_fk,
            iuseraffiliationkeyid_fk: access.iuseraffiliationkeyid_fk,
            iaccessfunctionid_fk: access.iaccessfunctionid_fk,
            iaccessroleid_fk: access.iaccessroleid_fk,
            iuserid_fk: access.iuserid_fk,
            iisactive: access.iisactive,
            strnotes: access.strnotes
          });
        },
        /**
         * @param {UserAccess} access
         * @returns {Promise}
         */
        updateAccess: function (access) {
          return $http.put(window.location.api('security/access/' + access.iuseraccessid), {
            iaccessscopeid_fk: access.iaccessscopeid_fk,
            iaccessfunctionid_fk: access.iaccessfunctionid_fk,
            iaccessroleid_fk: access.iaccessroleid_fk,
            iisactive: access.iisactive,
            strnotes: access.strnotes
          });
        },
        getAuthCounts: function (teamId) {
          return $http.get(window.location.api('security/auth_counts/team/' + teamId));
        },
        getUserByEmail: function (affiliation_key, email) {
          return $http.get(
            window.location.api(
              'security/lookup_user?email=' + email + '&affiliation_key=' + affiliation_key + '&affiliation_type=3'
          ));
        },
        getUserRoles: function () {
          return $http.get(window.location.api('security/user_roles/'));
        },
        getAccessFunctions: function () {
          return $http.get(window.location.api('security/access_functions/'));
        },
        getAccessScopes: function () {
          return $http({
            method: 'GET',
            url: window.location.api('security/access_scopes/'),
            transformResponse: transformResource
              .onResponse(function (data) {
                return _.orderBy(
                  data,
                  /**
                   * @param {UserAccessScope} data
                   * @returns {number}
                   */
                  function (data) {
                    switch (data.straccessscopedesc) {
                      case 'Team':
                        return 1;
                      case 'League':
                        return 2;
                      case 'Platform':
                        return 3;
                      case 'All Access':
                        return 4;
                      default:
                        return 5
                    }
                  }
                );
              })
          });
        }
      };
    }
  ]);





// WEBPACK FOOTER //
// ./app.v2/components/admin/passManager/passManagerService.js